import { isDev } from "./helpers/utilities";

// export const apiUrlTestSite = "https://diligentapps.com/ClientPortalApiTest/api/";
export const apiUrlProduction = "https://diligentapps.org/ClientPortalApi/api/";
export const apiUrl = isDev()
  ? "https://localhost:44354/api/"
  : apiUrlProduction;
export const tokenKeyName = "client-portal-token";
export const refreshKeyName = "client-portal-refresh";
export const localStorageVar = {
  displayNameKey: "displayName",
};
export const basePath = "/ClientPortal";
export const defaultTitle = "Diligent Client Portal";
export const constants = {
  CreatingOrder: {
    maxInvoices: 30,
    maxPieceCount: 99,
    freeInsuranceLimit: 200,
  },
  ActionCenterModes: {
    deliveryconcern: "Create a New Delivery Concern",
    codresearch: "Initiate COD Research",
    claim: "File a New Claim",
    return: "Request a Return",
  },
};
